var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 15.3588H10.8327L7.12434 17.8254C6.57434 18.1921 5.83268 17.8004 5.83268 17.1338V15.3588C3.33268 15.3588 1.66602 13.6921 1.66602 11.1921V6.19206C1.66602 3.69206 3.33268 2.02539 5.83268 2.02539H14.166C16.666 2.02539 18.3327 3.69206 18.3327 6.19206V11.1921C18.3327 13.6921 16.666 15.3588 14.166 15.3588Z",
    stroke: "#757B82",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 9.4668V9.29183C10.0005 8.72516 10.3505 8.42515 10.7005 8.18348C11.0422 7.95015 11.3838 7.65016 11.3838 7.10016C11.3838 6.33349 10.7672 5.7168 10.0005 5.7168C9.23383 5.7168 8.61719 6.33349 8.61719 7.10016",
    stroke: "#757B82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9969 11.4587H10.0044",
    stroke: "#757B82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.ff437b48bab9cd7a2282f4dbcad3c633.svg";
export { ForwardRef as ReactComponent };